import * as moment from "moment-timezone";
import { Translate, I18n } from "react-redux-i18n";

const AddingUsersTemplate =(automationName, description, resellerLineage, selectedListId) => {
	return {
		blueprint: {
			"name": automationName,
			"description": description,
			"editor_version": "2.01",
			"list_id": selectedListId,
			"trigger": [
				{
					"args": {
						"lineage": resellerLineage
					},
					"name": "User.Updated"
				},
				{
					"args": {
						"lineage": resellerLineage
					},
					"name": "User.Confirmed"
				}
			],
			"main": {
				"steps": [
					{
						"args": {
							"account_id": "${input.account_id}"
						},
						"name": "get_the_account",
						"action": "Account.Get"
					},
					{
						"args": {
							"is_account_owner": 0
						},
						"name": "init_is_account_owner",
						"action": "Variable.Set"
					},
					{
						"name": "check_if_delete",
						"action": "Condition.Switch",
						"args": {
							"switch": [
								{
									"steps": [
										{
											"args": {
												"in": [
													`${selectedListId}`
												],
												"value": "one_list_id"
											},
											"name": "update_all_lists",
											"action": "For.Loop",
											"steps": [
												{
													"args": {
														"list_id": "${one_list_id}",
														"email": "${input.data.user.email}",
														"custom_attributes": [
															{
																"name": "language",
																"value": "${input.data.user.language}"
															},
															{
																"name": "first_name",
																"value": "${input.data.user.first_name}"
															},
															{
																"name": "last_name",
																"value": "${input.data.user.last_name}"
															},
															{
																"name": "is_account_owner",
																"value": "${get_the_account_output.body.data.account_owner.user_id == input.data.user.id}"
															},
															{
																"name": "account_created_on",
																"value": "${get_the_account_output.body.data.created_on}"
															},
															{
																"name": "account_country",
																"value": "${get_the_account_output.body.data.address.country}"
															},
															{
																"name": "account_city",
																"value": "${get_the_account_output.body.data.address.city}"
															},
															{
																"name": "account_id",
																"value": "${input.account_id}"
															},
															{
																"name": "account_status",
																"value": "${get_the_account_output.body.data.status}"
															},
															{
																"name": "user_status",
																"value": "${input.data.user.status}"
															},
															{
																"name": "user_id",
																"value": "${input.data.user.id}"
															}
														]
													},
													"name": "Add_Contact",
													"action": "Contact.Add"
												}
											]
										}
									],
									"condition": {
										"eq": {
											"value": true,
											"var": "${input.data.user.status != \"deleted\"}"
										}
									}

								}
							]
						}
					}
				]
			},
			"sub_automations": []
		},
	};
};
export { AddingUsersTemplate};
